/* eslint-disable import/prefer-default-export */
import { CSSProperties } from 'react'
import { ToastContainer as BaseToastContainer } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'
import 'nprogress/nprogress.css'

import styles from './Toast.module.scss'

export const ToastContainer = () => {
  return (
    <BaseToastContainer
      position="bottom-right"
      hideProgressBar
      progressStyle={{ background: '#9da1ff' } as CSSProperties}
      newestOnTop
      autoClose={5000}
      className={styles.container}
      toastClassName={styles.toast}
      bodyClassName={styles.body}
      closeButton={false}
      // pauseOnFocusLoss
      draggable
      // pauseOnHover
      theme="dark"
    />
  )
}
